import styled from 'styled-components';
import { DefaultText } from '../../../styles/global/css/GlobalText';
import { PrimaryColor, SurfaceColor } from '../../../styles/global/css/Utils';

const MoreFilterToggle = styled.div`
    color: ${PrimaryColor};
    font-size: 12px;
    margin-right: 15px;
    cursor: pointer;
`;

interface ContainerProps {
  isActive?: boolean
}

const Container = styled.div<ContainerProps>`
    display: flex;
    height: 100%;
    flex-direction: row;
    align-items: center;
    background: ${p => p.isActive ? `color-mix(in oklab, ${PrimaryColor} 10%, transparent)` : SurfaceColor};
    border-radius: 5px;
    justify-content: space-evenly;
    cursor: pointer;
    padding: 10px;
`;

const Text = styled.p`
    ${DefaultText}
    color: ${() => PrimaryColor};
    font-weight: 500;
    font-size: 13px;
`;

export {
	MoreFilterToggle,
	Container,
	Text
};
